import { Public, Warehouse, WarehouseOutlined } from '@mui/icons-material';
import { StoreIcon } from 'components/svgIcons/StoreIcon';
import { atom } from 'jotai';

export const selectedCategoryDataAtom = atom({
  id: '0',
  name: 'global-settings',
  icon: <Public sx={{ fontSize: 28 }} />,
  label: 'تنظیمات عمومی',
});

export const selectedMobileBurgerTabDataAtom = atom({
  ...selectedCategoryDataAtom,
});

export const selectedRouteTitleAtom = atom('داشبورد');

export const isSidebarOpenAtom = atom(true);
export const isBottomBarOpenAtom = atom(false);

export const isMobileBurgerMenuOpenAtom = atom(false);
